module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.2f3e9f80.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/icons/linearicons/Linearicons-Free.ttf?w118d
// module id = ./src/assets/components/icons/linearicons/Linearicons-Free.ttf?w118d
// module chunks = 7